export class RaadplegenBestandenRequest {
  claimnummer: string;
}
